const HighlightsData = [
    {
        id: 1,
        detail: "Prime Location: Situated on NH24 in Ghaziabad, accessing Eden Wave City one can easily connect to Delhi, Noida, and other micro-markets in NCR along with the Eastern Peripheral Expressway and key cities.",
    },
    {
        id: 2,
        detail: "Smart City Features: Eden Wave City is located in Wave City Township which contains smart city facilities which include smart traffic systems, smart street lighting, and smart water management features depending on market needs.",
    },
    {
        id: 3,
        detail: "Luxurious Amenities: Luxury facilities for the residents include aesthetic greenery jogging and walking areas, gently manicured landscapes, a chic clubhouse, a fitness center, and state-of-the-art security around the clock.",
    },
    {
        id: 4,
        detail: "Sustainable Living: This is because Eden Wave City has environmentally friendly features such as; solar lighting, rainwater management, and electric vehicle charging.",
    },
    {
        id: 5,
        detail: "Spacious, Modern Homes: Having 2BHK and 3BHK, every home is well planned with wide space, stylish look, generous balconies, and the best standards of hardware fittings for providing the best of the modern lifestyle.",
    },
]

export default HighlightsData;